import Vue from 'vue';
import Router from 'vue-router';
import store from "../store";
import accountService from "../services/account.service";
import AccountVue from "@/views/Account";
import UsersVue from "@/views/Users";
import RolesVue from "@/views/Roles";
import DashboardVue from "@/views/Dashboard";
import SwissConstantVue from "../views/SwissConstant.vue";
import AirVolumeVue from "../views/AirVolume.vue";
import CusomerIdVue from "../views/CustomerId.vue";
import HeatCalculatorVue from '../views/HeatCalculator.vue';
import HeatingTableVue from "../views/HeatingTable.vue";
import HotWaterTableVue from "../views/HotWaterTable.vue";
import ServerSettingsVue from '../views/ServerSettings.vue';
import Tasks from "../views/Tasks.vue";
import HeatingTableSummarizedVue from "../views/HeatingTableSumarized.vue";
import HotWaterTableSummarizedVue from "../views/HotWaterTableSumarized.vue";
import RadiatorReplaceListVue from "../views/RadiatorReplaceList.vue";
import MeterReplaceListVue from "../views/MeterReplaceList.vue";
import HeatingPeriodListVue from "../views/HeatingPeriodList.vue";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Dashboard',
            component: DashboardVue,
        },
        {
            path: "/account",
            name: "Account",
            component: AccountVue
        },
        {
            path: "/users",
            name: "Users",
            component: UsersVue
        },
        {
            path: "/roles",
            name: "Roles",
            component: RolesVue
        },
        {
            path: '/server-settings',
            name: 'server-settings',
            component: ServerSettingsVue,
        },
        {
            path: "/swissconstant",
            name: "SwissConstant",
            component: SwissConstantVue
        },
        {
            path: "/airvolume",
            name: "AirVolume",
            component: AirVolumeVue
        },
        {
            path: "/cusomerid",
            name: "CusomerId",
            component: CusomerIdVue
        },
        {
            path: "/heatcalculator",
            name: "HeatCalculator",
            component: HeatCalculatorVue
        },
        {
            path: "/radiatorreplacelist",
            name: "RadiatorReplaceList",
            component: RadiatorReplaceListVue
        },
        {
            path: "/heatingtablesummarized",
            name: "HeatingTableSummarized",
            component: HeatingTableSummarizedVue
        },
        {
            path: "/meterreplacelist",
            name: "MeterReplaceList",
            component: MeterReplaceListVue
        },
        {
            path: "/hotwatertablesummarized",
            name: "HotWaterTableSummarized",
            component: HotWaterTableSummarizedVue
        },
        {
            path: "/heatingtable/:id",
            name: "HeatingTable",
            component: HeatingTableVue
        },
        {
            path: "/heatingperiodlist",
            name: "HeatingPeriod",
            component: HeatingPeriodListVue
        },
        {
            path: "/hotwatertable/:id",
            name: "HotWaterTable",
            component: HotWaterTableVue
        },
        {
            path: "/tasks",
            name: "Tasks",
            component: Tasks
        },
        {
            path: "/developmentInfo/bugReports",
            name: "Bugreports",
            component: Tasks
        },
        {
            path: "/developmentInfo/featureRequests",
            name: "ImprovementProposals",
            component: Tasks
        },
        {
            path: "/developmentInfo/changelog",
            name: "DevelopmentDiary",
            component: Tasks
        },
        {
            path: '*',
            redirect: '/'
        }
  ],
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push(
    location,
    onComplete,
    onAbort
) {
  if (onComplete || onAbort)
return originalPush.call(this, location, onComplete, onAbort);
return originalPush.call(this, location).catch((err) => err);
};

router.beforeEach(async (to, from, next) => {
  to.matched.forEach(record => {
    if (record.meta.permissions) {
      if (!accountService.userHasPermissions(record.meta.permissions)) {
        next("/");
      }
    }
  });

  if (store.getters.isSessionExpired && to.path != '/login') {
     next("/login");
     return;
   }

  next();
});

export default router;
